import type { HeatmapMode } from '@chessmate/protocol';

/**
 * Overlay mode → translation key in the `games` namespace.
 *
 * This map is the reason the labels are exhaustive *and* translated. The
 * previous arrangement had `HEATMAP_MODE_LABELS` living in `packages/ui` as
 * hardcoded English, while `heat-map-off` / `heat-map-control` /
 * `heat-map-territory` sat fully translated in `locales/{fr,es}/games.json` and
 * nothing ever read them — a French kid saw "Heat map: Control" in English
 * because the copy existed and just wasn't wired to it.
 *
 * Typed `Record<HeatmapMode, string>` so a new mode with no key is a compile
 * error rather than a label that renders as the raw key.
 *
 * Per `packages/ui/src/InstallButton.tsx`, the UI package takes resolved
 * strings and this app resolves them — `packages/ui` has no i18n dependency and
 * deliberately keeps none.
 */
export const HEATMAP_MODE_I18N_KEYS: Record<HeatmapMode, string> = {
  off: 'heat-map-off',
  control: 'heat-map-control',
  territory: 'heat-map-territory',
  power: 'heat-map-power',
};
